import React from 'react';
// import narratoLogo from '../assets/narrato-icon.png'; // Adjust the path based on where you place your image in the src/assets folder
import bakeonatorLogo from '../assets/images/logos/bakeonator_logo.png'; // Adjust the path as necessary

function NavBar() {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-secondary fixed-top">
            <div className="container">
                <a className="navbar-brand" href="/">
                    <img src={bakeonatorLogo} alt="Bakeonator Logo"
                         width="auto" // Set the width as desired
                         height="50" // Set the height as desired
                    />

                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false"
                        aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                    <div className="navbar-nav ms-auto">
                        <a className="nav-link" href="#features">Features</a>
                        <a className="nav-link" href="#pricing">Pricing</a>
                        <a className="nav-link" href="/login">Log In</a>
                        <a className="btn btn-light ms-2" href="/signup">Sign Up</a>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default NavBar;

/*
import React from 'react';
import {Container, Navbar, Nav} from 'react-bootstrap';
import logo from './assets/images/logos/bakeonator_logo.png'; // Adjust the path as necessary

const NavBar = () => {
    return (
        <Navbar bg="light" expand="lg">
            <Container>
                <Navbar.Brand href="#home">
                    <img
                        src={logo}
                        width="auto" // Set the width as desired
                        height="50" // Set the height as desired
                        className="d-inline-block align-top"
                        alt="Logo"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link href="#features">Features</Nav.Link>
                        <Nav.Link href="#pricing">Pricing</Nav.Link>
                        <Nav.Link href="#login">Login</Nav.Link>
                        <Nav.Link href="#signup">Sign Up</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default NavBar;
*/

